// extracted by mini-css-extract-plugin
export default {"container":"to-z","heading":"uo-z","items":"vo-z","action":"wo-z","disabled":"xo-z"};